import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FiltroActividades } from 'src/app/shared/models/filtroActividades';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiServerService } from 'src/app/core/services/api/api-server.service';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  spinner = true;
  listRegistros: any[] = [];
  page = 1;
  formDatos: FormGroup;
  total: number;
  totalResults: any[] = [];
  pages_total = 0;
  filtros = new FiltroActividades;
  filtrosCompletados = false;
  constructor(private form: FormBuilder,
    private router: Router,
    private services: ApiServerService,
    private _snackBar: MatSnackBar,) {

    $('#spinner-load').css("display", "block");

    let filtros = localStorage.getItem('filtroActividadesHome')
    if (!filtros) {
      this.filtros = new FiltroActividades();
    } else {
      this.filtros = JSON.parse(filtros);

    }


    this.formDatos = this.form.group({
      category: [this.filtros.category],
      mision: [this.filtros.mision],
      dateFrom: [this.filtros.dateFrom],
      dateUntil: [this.filtros.dateUntil],
      protocol: [this.filtros.protocol],
      state: [this.filtros.state],

    });
    this.cargarLista()
  }



  ngOnInit(): void {

  }

  ngAfterViewInit() {


    $('.ui.dropdown').dropdown({
      "clearable": true
    });

    $('.ui.selection.dropdown').dropdown({
      "clearable": true
    });
  }
  categoryFilters: any = [];
  stateFilters: any = [];
  protocolFilters: any = [];
  misionFilters: any = [];
  cargarLista() {
    $('#spinner-load').css("display", "block");

    this.services.getAllResults(this.page, 15, this.filtros).subscribe(res => {
      this.listRegistros = res.data;
      this.pages_total = res.totalPages;
      this.page = res.pageNumber;
      this.categoryFilters = res.categoryList;
      this.misionFilters = res.misionList;
      this.stateFilters = res.stateUtList;
      this.protocolFilters = res.protocolList;
      this.spinner = false;
      $('#spinner-load').css("display", "none");
    },
      error => {
        this._snackBar.open('Ocurrio un error al cargar los datos', 'x', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['error-snackbar'],
        });
        $('#spinner-load').css("display", "none");

      })

  }

  completarFiltros() {

    this.filtrosCompletados = true;

  }


  detalle(item) {
    this.router.navigate(["detalle/" + item.Mission_Id  ]);
  }



  limpiar() {
    this.page = 1;
    this.filtros = null;
    this.formDatos.controls['category'].setValue(null)
    this.formDatos.controls['mision'].setValue(null)
    this.formDatos.controls['dateFrom'].setValue(null)
    this.formDatos.controls['dateUntil'].setValue(null)
    this.formDatos.controls['protocol'].setValue(null)
    this.formDatos.controls['state'].setValue(null)
    this.filtros = new FiltroActividades();
    localStorage.setItem('filtroActividadesHome', JSON.stringify(this.filtros))
    $('.ui.dropdown').dropdown('restore defaults');

    this.cargarLista()
  }

  changePage(number_page: number) {
    this.page = number_page;
    this.cargarLista();
  }

  aplicar() {
    this.page = 1;
    this.filtros = new FiltroActividades();
    this.filtros.category = this.formDatos.get('category').value;
    this.filtros.mision = this.formDatos.get('mision').value;
    this.filtros.dateFrom = this.formDatos.get('dateFrom').value;
    this.filtros.dateUntil = this.formDatos.get('dateUntil').value;
    this.filtros.protocol = this.formDatos.get('protocol').value;
    this.filtros.state = this.formDatos.get('state').value;

    localStorage.setItem('filtroActividadesHome', JSON.stringify(this.filtros))

    $('#spinner-load').css("display", "block");

    this.cargarLista()


  }
  setForm(event){
    this.formDatos.controls[event.name].setValue(event.value)
  }
  changeOrder(value) {
    this.filtros.orderWhen = value;
    this.page=1;
    this.cargarLista();
  }


}
